import Immutable from 'seamless-immutable';

export default () =>
  Immutable({
    __record: 'CameraRecord',
    cameraAllowed: false,
    cameraNotFound: false,
    cameraLoading: false,
  });
